import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useStore } from '../../../core/utils/hook';
import { SYSTEM_PATH } from '../../../core/configs/constants';

import './style.scss';

const FloatButtonContact = observer(() => {
    // hook
    const navigate = useNavigate();

    // store
    const {
        authStore: { token }
    } = useStore();

    return !token ? (
        <div
            className="float-button-contact"
            onClick={() => navigate(SYSTEM_PATH.SEND_INQUIRY)}
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <mask
                    id="mask0_1569_4934"
                    style={{ maskType: 'luminance' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                >
                    <path d="M24 0H0V24H24V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_1569_4934)">
                    <path
                        d="M2 4V20H22V4H2ZM20.4 5.5L12 11.9L3.59998 5.5H20.4ZM3.5 18.5V7.29999L12 13.8L20.5 7.29999V18.5H3.5Z"
                        fill="white"
                    />
                </g>
            </svg>
            <span className="text">問い合わせ</span>
        </div>
    ) : (
        <></>
    );
});

export default FloatButtonContact;
